import "./src/styles/global.css"
require("prismjs/themes/prism-solarizedlight.css")

// export const onServiceWorkerUpdateReady = () => {
// console.log(
//   "onServiceWorkerUpdateReady hook triggered: force reloading page."
// )
// window.location.reload(true)
// }